export default __webpack_public_path__ + "static/media/trafficpolice_color.3097a1b0.png";